<template>
  <div>
    <div class="md-layout">
      <div
        class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-15"
      >
        <md-field>
          <label>{{ $t('planning.overall_budget') }}</label>
          <md-input
            v-model.number="totalBudget"
            @input="onChangeTotal"
          ></md-input>
        </md-field>
      </div>
    </div>
    <p></p>
    <div class="md-layout">
      <div
        class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-15"
      >
        <p>{{ $t('planning.periodic_maintenance') }}</p>
        <md-field>
          <md-input
            v-model.lazy="periodicPercent"
            @input="onChangePeriodicPercent"
          ></md-input>
          <md-icon>%</md-icon>
        </md-field>
        <md-field>
          <md-input
            v-model.lazy="periodicBudget"
            @input="onChangePeriodicBudget"
          ></md-input>
          <md-icon>money</md-icon>
        </md-field>
      </div>
      <div
        class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-15"
      >
        <p>{{ $t('planning.routine_maintenance') }}</p>
        <md-field>
          <md-input type="number" :value="routinePercent" readonly></md-input>
          <md-icon>%</md-icon>
        </md-field>
        <md-field>
          <md-input :value="routineBudget" type="number" readonly></md-input>
          <md-icon>money</md-icon>
        </md-field>
      </div>
    </div>
    <p></p>
    <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-30">
      <div class="range-element">
        <input @input="onChangeRange" type="range" :value="periodicPercent" />
        <span>%</span>
      </div>
    </div>
    <div
      class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-30 "
    >
      <div class="buttons-zone">
        <md-button class="md-raised md-success" @click="onSavePlanParams">
          {{ $t('button.save') }}
        </md-button>
        <md-button class="md-raised" @click="onGoBack">
          {{ $t('button.back') }}
        </md-button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'planning-props',
  props: {
    plan_id: {type: String}
  },
  data() {
    return {
      totalBudget: 0,
      periodicPercent: 0,
      periodicBudget: 0
    }
  },
  async created() {
    //const {plan_id} = this.$router.params
    try {
      const budget = await this.$store.dispatch(
        'LOAD_PLAN_PARAMS',
        +this.plan_id
      )
      const {total_budget, periodic_budget, routine_budget} = budget
      this.totalBudget = total_budget
      this.periodicBudget = periodic_budget
      this.recalcPercent()
    } catch (err) {
      console.log({err})
    }
  },
  methods: {
    onChangeRange(evt) {
      this.periodicPercent = evt.target.value
    },
    onChangeTotal() {
      this.recalcBudget()
    },
    recalcBudget() {
      this.periodicBudget =
        this.totalBudget === 0
          ? 0
          : Math.round((this.totalBudget / 100) * this.periodicPercent)
    },
    recalcPercent() {
      const perc =
        this.totalBudget === 0
          ? 0
          : (100 * this.periodicBudget) / this.totalBudget
      this.periodicPercent = Math.round((perc + Number.EPSILON) * 100) / 100
    },
    onChangePeriodicPercent(val) {
      //this.periodicPercent = val
      this.recalcBudget()
    },
    onChangePeriodicBudget(val) {
      this.recalcPercent()
    },
    onGoBack() {
      this.$router.go(-1)
    },
    async onSavePlanParams() {
      try {
        const first_plan_state_type = 'periodic'
        const plan_id = this.plan_id
        const total_budget = this.totalBudget
        const periodic_budget = this.periodicBudget
        const routine_budget = this.routineBudget
        const state = ''
        const payload = {
          plan_id,
          params: {total_budget, periodic_budget, routine_budget, state}
        }
        await this.$store.dispatch('SET_PLAN_PARAMS', payload)
        await this.$store.dispatch('GENERATE_PLAN_DATA', {
          plan_id: this.plan_id,
          type: first_plan_state_type
        })
        await this.$store.dispatch('SET_PLAN_PARAMS', {
          plan_id,
          params: {state: first_plan_state_type}
        })

        this.$router.push({
          name: 'Planning-data',
          params: {plan_id, page: 1, type: first_plan_state_type}
        })
      } catch (err) {
        console.log({err})
      }
    }
  },
  computed: {
    routinePercent() {
      return Math.round((100 - this.periodicPercent) * 100) / 100
    },
    routineBudget() {
      return Math.round(this.totalBudget - this.periodicBudget)
    }
  }
}
</script>
<style lang="scss">
.range-element {
  display: flex;
  input[type='range'] {
    width: 100%;
  }
}
.md-layout-item {
  padding-top: 5px;
}
.buttons-zone {
  padding-top: 30px;
  button {
    margin-right: 10px;
  }
}
</style>
